module.exports = __webpack_public_path__ + "img/icon-export.d4d404a7.svg";